// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a9ab938","453":"d3a5793d","732":"7db538ad"}[chunkId] + ".chunk.js";
};